exports = module.exports = require("../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-image-pro--avatar{display:inline-block;text-align:center;vertical-align:middle}", ""]);

// exports
